module.exports = __webpack_public_path__ + "static/media/993817.5dbafca3.png";